import React from 'react';
import { Box, Pagination, Typography, useTheme, useMediaQuery } from '@mui/material';

interface MatchPaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  disabled?: boolean;
}

export const MatchPagination: React.FC<MatchPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  disabled = false
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const handleChange = (_event: React.ChangeEvent<unknown>, page: number) => {
    onPageChange(page);
  };

  // Don't render if only one page
  if (totalPages <= 1) {
    return null;
  }

  // Determine number of page buttons to show based on screen size
  let siblingCount = 1; // Default for desktop (shows 7 pages)
  if (isMobile) {
    siblingCount = 0; // Mobile shows 3 pages max
  } else if (isTablet) {
    siblingCount = 1; // Tablet shows 5 pages
  }

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        gap: 1,
        mt: 2 
      }}
    >
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={handleChange}
        disabled={disabled}
        siblingCount={siblingCount}
        boundaryCount={1}
        showFirstButton
        showLastButton
        sx={{
          '& .MuiPagination-ul': {
            justifyContent: 'center'
          }
        }}
      />
      <Typography variant="caption" color="text.secondary">
        Page {currentPage} of {totalPages}
      </Typography>
    </Box>
  );
};
